import React from "react";
import styles from "./index.module.css";
import Modal from "../../../../../components/common/ModalV2/Modal.jsx";
import modalClose from "../../../../../assets/modalClose2.png";
import Product from "../Product/index.jsx";

const ProductsBottomSheet = ({ isOpen, closeModalHandler, products }) => {
    const alignItems = "flex-end";

    return (
        <>
            <Modal showModal={isOpen} onClose={closeModalHandler} alignItems={alignItems}>
                <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                    <div className={styles.header}>
                        <div className={styles.title}>Tagged Products</div>
                        <div
                            className={styles.closeButton}
                            style={{ backgroundImage: `url(${modalClose})` }}
                            onClick={closeModalHandler}
                        ></div>
                    </div>
                    <div className={styles.attachedProduct}>
                        <div className={styles.productsGrid}>
                            {products?.map((e, i) => (
                                <div className={styles.productCell} key={i}>
                                    <Product productInfo={e} hideIcon={true} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ProductsBottomSheet;
